import { getBusinessUser, getBusinessUserOnly } from '../services/userService'

import types from './types'

const { FETCH_USER } = types

export function fetchGetBusinessUserOnly(token) {
  return dispatch =>
    getBusinessUserOnly(token).then(user => {
      dispatch({
        type: FETCH_USER,
        state: {
          ...user,
          token
        }
      })
    })
}

function fetchGetBusinessUser(token) {
  return dispatch =>
    getBusinessUser(token).then(user => {
      dispatch({
        type: FETCH_USER,
        state: {
          ...user,
          token
        }
      })

      return user
    })
}

export default fetchGetBusinessUser



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchGetBusinessUser.js